if (!customElements.get('ff-swatch-color')) {
  customElements.define('ff-swatch-color', class FfSwatchColor extends HTMLElement {
  constructor(){
    super();
    this.firstOption = this.querySelector(".ff-first-option");
    this.boxVariants = this.querySelector(".ff-selector-options");
    this.allOptions = this.boxVariants.querySelectorAll(".color-swatch");
    this.addListener();
  }

  addListener() {
    this.firstOption.addEventListener("click", () => {
      this.showBox();
    });
    this.allOptions.forEach( option => {
      option.addEventListener("click", () => {
        this.hideBox();
        this.changeId(option.dataset.variantId);
      })
    });
    this.addEventListener("mouseleave", () => {
      this.hideBox();
    })
  } 

  showBox() {
    this.boxVariants.classList.remove("ff-hide");
  }

  hideBox() {
    this.boxVariants.classList.add("ff-hide");
  }

  changeId(id) {
    const productForm = this.parentElement.nextElementSibling;
    const idForm = productForm.querySelector('input[name="id"]');
    idForm.value = id;
  }
});
}
